"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassesMemberCount = exports.getClassesStudnet = exports.getClassesSliceMember = exports.getClassesMember = exports.getClassesId = exports.getHiddenMenus = exports.getClassesTitle = exports.getClasses = void 0;
const regist_1 = require("../../../redux/regist");
const function_1 = require("../../menu/function");
const getClasses = (statful) => {
    const state = (0, regist_1.toState)(statful);
    return state['base/classes'].classes;
};
exports.getClasses = getClasses;
const getClassesTitle = (statful) => {
    const classes = (0, exports.getClasses)(statful);
    return classes?.title;
};
exports.getClassesTitle = getClassesTitle;
const getHiddenMenus = (statful) => {
    const classes = (0, exports.getClasses)(statful);
    return (0, function_1.normalizeHiddenMenus)(classes?.hidden_menus || []);
};
exports.getHiddenMenus = getHiddenMenus;
// location 객체에서 URL에서 UUID 추출
const extractClassIdFromPath = (pathname) => {
    const uuidRegex = /\/class\/([0-9a-fA-F-]+)/; // UUID 추출 정규표현식
    const match = pathname.match(uuidRegex);
    return match ? match[1] : undefined;
};
const getClassesId = () => {
    const { pathname } = location;
    const classIdFromUrl = extractClassIdFromPath(pathname); // URL에서 UUID 추출
    const fallbackId = (0, exports.getClasses)(APP.store.getState)?.id; // fallback ID (state에서 가져옴)
    return classIdFromUrl || fallbackId;
};
exports.getClassesId = getClassesId;
/**
 * 클래스에 속하는 그룹 멤버 아이디 가져온다
 * @param statful
 * @returns
 */
const getClassesMember = (statful) => {
    const classes = (0, exports.getClasses)(statful);
    return [...classes?.members, ...classes?.managers, classes?.host] || [];
};
exports.getClassesMember = getClassesMember;
const getClassesSliceMember = (statful, count) => {
    return (0, exports.getClassesMember)(statful).splice(0, count);
};
exports.getClassesSliceMember = getClassesSliceMember;
//학생 id만 가져옴
const getClassesStudnet = (statful) => {
    const classes = (0, exports.getClasses)(statful);
    return [...classes?.members] || [];
};
exports.getClassesStudnet = getClassesStudnet;
const getClassesMemberCount = (statful) => {
    const members = (0, exports.getClassesMember)(statful);
    return members.length || 0;
};
exports.getClassesMemberCount = getClassesMemberCount;
